// On-screen joystick → movement, read each frame by WalkControls / InteriorWalk
// (analog, added alongside WASD). x = strafe (right +), y = forward (+). Touch
// devices can drag-to-look but have no keyboard; this gives them locomotion.
export const moveBridge = { x: 0, y: 0 };
